<template>
    <i class="wy-permission-icon"
        v-bind="$attrs"
        :loading="loading"
        @click="handleClick"
        v-if="visible">
        <slot></slot>
    </i>
</template>

<script>
import permission from '../../../mixins/permission.js';
export default {
    name: 'wy-permission-icon',
    mixins: [permission],
    inheritAttrs: false,
    props: {
        // 自定义属性
    },
    data() {
        return {
            // 自定义数据
        }
    },
    methods: {
        // 自定义方法
    },
    watch: {
        // 自定义监听
    },
    created() {
        // 自定义生命周期
    },
    mounted() {
        // 自定义挂载
    },
    computed: {
        // 自定义计算
    },
    beforeDestroy() {
        // 自定义销毁
    }
}
</script>

<style scoped lang="scss">
.wy-permission-icon {
    cursor: pointer;
    padding: 10px;
    color: #20C6B1;
}
</style>